const START_PARAM_MAX_LENGTH = 128
const IDENTIFIER_MAX_LENGTH = 128

const ALLOWED_TOKEN_REGEXP = /^[A-Za-z0-9_-]+$/

const normalizeString = (value: unknown): string | null => {
  if (typeof value !== 'string') {
    return null
  }

  const normalized = value.trim()
  return normalized.length > 0 ? normalized : null
}

export const sanitizeStartParam = (value: unknown): string | null => {
  const normalized = normalizeString(value)
  if (!normalized) {
    return null
  }

  if (normalized.length > START_PARAM_MAX_LENGTH) {
    return null
  }

  if (!ALLOWED_TOKEN_REGEXP.test(normalized)) {
    return null
  }

  return normalized
}

export const sanitizeIdentifier = (value: unknown): string | null => {
  const normalized = normalizeString(value)
  if (!normalized) {
    return null
  }

  if (normalized.length > IDENTIFIER_MAX_LENGTH) {
    return null
  }

  if (!ALLOWED_TOKEN_REGEXP.test(normalized)) {
    return null
  }

  return normalized
}

export const sanitizeReferralCode = (value: unknown): string | null => {
  const normalized = normalizeString(value)
  if (!normalized) {
    return null
  }

  if (normalized.length > IDENTIFIER_MAX_LENGTH) {
    return null
  }

  if (!ALLOWED_TOKEN_REGEXP.test(normalized)) {
    return null
  }

  return normalized
}
